import { render, staticRenderFns } from "./LoaderView.vue?vue&type=template&id=c3b8e604&scoped=true&"
import script from "./LoaderView.vue?vue&type=script&lang=js&"
export * from "./LoaderView.vue?vue&type=script&lang=js&"
import style0 from "./LoaderView.vue?vue&type=style&index=0&id=c3b8e604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b8e604",
  null
  
)

export default component.exports